import React, { forwardRef, useMemo } from "react";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import SDElementsMappingForm from "./SDElementsMappingForm";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

function SDElementsCredentialsForm(props, ref) {
  const fields = useMemo(
    () => [
      {
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
      },
      {
        name: "apiToken",
        label: "Api Token",
        type: FieldTypes.PASSWORD,
        required: true,
      },
    ],
    []
  );

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={SDElementsMappingForm}
    />
  );
}

export default forwardRef(SDElementsCredentialsForm);
